<template>
  <ul class="lm-banner">
    <li class="lm-banner_item" v-for="(item, i) in list">
      <div class="lm-banner_title">{{ item.title }}</div>
      <div class="lm-banner_intro">{{ item.intro }}</div>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.lm-banner {
  display: flex;
  // margin-top: 43.75px;
  // margin-bottom: 43.75px;
  border-top: 1px solid #999;
  border-bottom: 1px solid #999;
  padding-top: 35px;
  padding-bottom: 35px;
}
.lm-banner_item {
  flex: 1;
  text-align: center;
}
.lm-banner_title {
  line-height: 46.3867px;
  font-size: 37.1094px;
  font-weight: 700;
}
.lm-banner_intro {
  font-size: 23.75px;
}
</style>

<script>
export default {
  props: {
    list: {
      type: Array,
      require: true
    }
  }
}
</script>
